// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"157":"what","258":"blogMenu","394":"skill","421":"bubble","897":"carousel","903":"skill-list"}[chunkId] || chunkId) + ".bundle.js";
};